const migration = new Date('2025-03-01').getTime();

export type __VersionedSettingsState__v0 = {
  ui: {
    sidebarIsOpen: boolean;
  };
};

function migration_20250301_initial_migration(
  state: unknown,
  version: number,
): __VersionedSettingsState__v0 {
  console.log('initial: Migrating settings');
  if (version < migration) {
    console.log('initial: Migrated');
    return {
      ui: {
        sidebarIsOpen: true,
      },
    };
  }

  return state as __VersionedSettingsState__v0;
}

export {migration_20250301_initial_migration};
